import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './VHubAiPage.css';
import { NetworkManager } from '../../Components/NetworkManager';
import { CommonUtil } from '../../utils/CommonUtil';





const VHubAiPage = () => {
  const iframeRef = useRef<any>(null);
  const location = useLocation();
  const defaultUrl = "https://d2rx7528f4g2up.cloudfront.net";
  const baseUrl = CommonUtil.VHUB_AI_URL || defaultUrl;
  const path = location.pathname.replace(/^\/vhubai/, "");
  const iframeSrc = `${baseUrl}${path}`;
  console.log(iframeSrc, "iframeSrc");
  const getDbSchemaFromServerPath = (serverPath: string) => {
    if (!serverPath) return "";

    let host = serverPath;
    try {
      host = new URL(serverPath).host.toLowerCase();
    } catch (e) {
      host = serverPath.toLowerCase();
    }

    if (host.includes('apiqa.')) return 'QA';
    if (host.includes('apistaging.')) return 'Staging';
    if (host.includes('universalapi.') || host.includes('vhubapp.com')) return 'Universal';
    return '';
  };

  useEffect(() => {
    const sendMessage = () => {
      const serverPath = NetworkManager.serverPath || "";
      const baseUrl = window.location.hostname === "localhost" ? "http://localhost:8000/v1" :  getDbSchemaFromServerPath(serverPath) === "QA" || getDbSchemaFromServerPath(serverPath) === "Staging" ? "https://vhub-sttm.soulax.io/v1" : "https://sttmapi.vhubapp.com/v1";
      const data = { 
        token: `${localStorage.getItem("token")}`,
        orgName: `${localStorage.getItem("orgName")}` ,
        user: `${localStorage.getItem("user")}`,
        dbSchema: getDbSchemaFromServerPath(serverPath),
        baseUrl: baseUrl,
        siteUrl: `vhub`,
      };
      console.log(data, "iFramedata");
      if (iframeRef.current) {
        iframeRef.current.contentWindow?.postMessage(data, "*")
      }
    };

    const handleMessage = (event: any) => {
      console.log('event.data', event?.data?.type);
      if (event.data.type === "VHUB_READY" || event.data.type === "AI_APP_READY") {
        sendMessage();
        console.log("Received in B:", event.data.value);
      }
    };

    // Add listener when component mounts
    window.addEventListener('message', handleMessage);

    // Clean up listener when component unmounts to prevent memory leaks
    return () => window.removeEventListener('message', handleMessage);
  }, []);

    return (
        <div>
          <div className="vhub-ai-container">
              <iframe
                ref={iframeRef}
                src={iframeSrc}
                name="vhubAiFrame"
                title="vhub AI"
                className="vhub-ai-iframe"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
          </div>
        </div>
    );
};

export default VHubAiPage;